module.exports = __webpack_public_path__ + "static/media/gamasonic.c22d33d9.png";